"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrowserLocation = void 0;
const mapParamsHandler_1 = require("./mapParamsHandler");
const DEFAULT_ZOOM = 12;
const getBrowserLocation = (map, setUrlParams) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(`https://www.googleapis.com/geolocation/v1/geolocate?key=${process.env.GOOGLE_MAPS_API_KEY}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                considerIp: true,
            }),
        });
        const data = yield response.json();
        if (data.location) {
            const { lat, lng } = data.location;
            setUrlParams([
                {
                    key: mapParamsHandler_1.UrlParamsTypes.currentCenter,
                    value: JSON.stringify({ lat, lng }),
                },
                {
                    key: mapParamsHandler_1.UrlParamsTypes.currentZoom,
                    value: DEFAULT_ZOOM.toString(),
                },
            ]);
            map === null || map === void 0 ? void 0 : map.setZoom(DEFAULT_ZOOM);
            map === null || map === void 0 ? void 0 : map.panTo({ lat, lng });
            return { lat, lng };
        }
        return null;
    }
    catch (error) {
        return null;
    }
});
exports.getBrowserLocation = getBrowserLocation;
